import ClubOfficers from './ClubOfficers';

export default ClubOfficers;
